import React, { createContext, useState, useContext } from 'react';
import {
    anonimizarNome,
    anonimizarEmail,
    anonimizarDocumento,
    anonimizarCodigo,
    anonimizarCampo,
    anonimizarCanal
} from '../utils/anonymizeUtils';

const AnonymizeContext = createContext({});

export function AnonymizeProvider({ children }) {
    const canAnonymize = true;

    // Estado da anonimização ativada/desativada sincronizada com apex_anonymize_enabled
    const [isAnonymized, setIsAnonymized] = useState(() => {
        const saved = localStorage.getItem('apex_anonymize_enabled');
        return saved === 'true';
    });

    const toggleAnonymize = () => {
        setIsAnonymized(prev => {
            const next = !prev;
            localStorage.setItem('apex_anonymize_enabled', String(next));
            try {
                window.dispatchEvent(new CustomEvent('apex_anonymize_changed', { detail: next }));
                window.dispatchEvent(new Event('storage'));
            } catch (e) {
                console.error('Error dispatching anonymize event:', e);
            }
            return next;
        });
    };

    // Formatadores condicionais
    const maskNome = (val) => (isAnonymized ? anonimizarNome(val) : val);
    const maskEmail = (val) => (isAnonymized ? anonimizarEmail(val) : val);
    const maskDocumento = (val) => (isAnonymized ? anonimizarDocumento(val) : val);
    const maskCodigo = (val) => (isAnonymized ? anonimizarCodigo(val) : val);
    const maskCampo = (val, tipo) => (isAnonymized ? anonimizarCampo(val, tipo) : val);
    const maskCanal = (val, tipo) => (isAnonymized ? anonimizarCanal(val, tipo) : val);

    return (
        <AnonymizeContext.Provider value={{
            canAnonymize,
            isAnonymized,
            toggleAnonymize,
            maskNome,
            maskEmail,
            maskDocumento,
            maskCodigo,
            maskCampo,
            maskCanal
        }}>
            {children}
        </AnonymizeContext.Provider>
    );
}

export const useAnonymize = () => useContext(AnonymizeContext);
